import React from 'react';

class Financing extends React.Component {
    render() {
        return (
            <div className='dms-body'>
                {this.props.children}
            </div>
        )
    }
};
export default Financing;



// WEBPACK FOOTER //
// ./src/routes/financing/index.js